export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded datetime */
  ISO8601String: any;
  /** A object contains pairs of key and value */
  KeyValueObject: any;
  /** Hash(Object) of Time */
  TimeObject: any;
  /** A void value */
  Void: any;
};

export type AdAnalyticsNetwork = {
  key: Scalars['String'];
  name: Scalars['String'];
  placements: Array<AdAnalyticsPlacement>;
};

export type AdAnalyticsPlacement = {
  external_api_key: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type AdAnalyticsPlatform = {
  key: Scalars['String'];
  name: Scalars['String'];
  networks: Array<AdAnalyticsNetwork>;
};

export type AspectRatio = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type Basic = {
  creativeType: SupportingCreativeType;
  isModificationRequestable: Scalars['Boolean'];
  isResizable: Scalars['Boolean'];
};

export type BusinessRegion = {
  idBusinessRegion: BusinessRegionIdBusinessRegion;
  key: BusinessRegionAdRegionKey;
  timeZone: Scalars['String'];
};

export enum BusinessRegionAdRegionKey {
  Gl = 'gl',
  Jp = 'jp',
  Us = 'us'
}

export enum BusinessRegionIdBusinessRegion {
  Global = 'global',
  Japan = 'japan',
  UnitedStates = 'united_states'
}

export type Creation = {
  achievementId?: Maybe<Scalars['ID']>;
  assignee?: Maybe<UserOptimizer>;
  assignmentId: Scalars['ID'];
  createdAt: Scalars['ISO8601String'];
  creationSetId: Scalars['ID'];
  creativeFormat: CreativeFormat;
  deliverables: Array<Deliverable>;
  id: Scalars['ID'];
  inspectionModificationRequests: Array<InspectionRequest>;
  isNextModificationRequestForAFee: Scalars['Boolean'];
  latestDeliverableSubmittedAt?: Maybe<Scalars['ISO8601String']>;
  latestDeliverableUrl?: Maybe<Scalars['String']>;
  latestProposedDeliverable?: Maybe<Deliverable>;
  modificationRequestExpired: Scalars['Boolean'];
  modificationRequestFreeExpiredAt?: Maybe<Scalars['ISO8601String']>;
  modificationRequestFreeLimit: Scalars['Int'];
  modificationRequestPoint: Scalars['Int'];
  modificationRequestReward: Reward;
  modificationRequests: Array<Request>;
  organization: Organization;
  projectId: Scalars['ID'];
  proposed: Scalars['Boolean'];
  resizeBaseId?: Maybe<Scalars['ID']>;
  state: CreationState;
  stateUpdatedAt: Scalars['ISO8601String'];
  submittedAt?: Maybe<Scalars['ISO8601String']>;
};

export type CreationSet = {
  additionalAmount: Scalars['Int'];
  amount: Scalars['Int'];
  creations: Array<Creation>;
  creationsByAssignmentId: Array<Creation>;
  creationsByOtherAssignedOptimizers: Array<Creation>;
  creativeFormats: Array<CreativeFormat>;
  currentAssignmentId: Scalars['ID'];
  deliveryDueDate?: Maybe<Scalars['ISO8601String']>;
  deliveryDueDays?: Maybe<Scalars['Int']>;
  expressDueDays?: Maybe<Scalars['Int']>;
  finalizedAt?: Maybe<Scalars['ISO8601String']>;
  id: Scalars['ID'];
  inspectionPassedCreations?: Maybe<Array<Creation>>;
  offerId?: Maybe<Scalars['ID']>;
  project: Project;
};

export enum CreationState {
  Canceled = 'canceled',
  InInspection = 'in_inspection',
  InProposal = 'in_proposal',
  Initial = 'initial',
  InspectionModificationRequested = 'inspection_modification_requested',
  ModificationRequested = 'modification_requested',
  Submitted = 'submitted'
}

export type Creative = {
  fastStart?: Maybe<CreativeFastStart>;
  file: File;
  id: Scalars['ID'];
};

export type CreativeFastStart = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type CreativeFormat = {
  attribute: CreativeFormatAttribute;
  creativeType: CreativeFormatCreativeType;
  id: Scalars['ID'];
  network: CreativeFormatNetwork;
  offerPricingDetails?: Maybe<OfferPricingDetail>;
  placement: CreativeFormatPlacement;
  resizeBaseId?: Maybe<Scalars['ID']>;
  selectedPricingMerchandiseOptions: Array<Option>;
};

export type CreativeFormatAspectRatio = {
  aspectRatio: AspectRatio;
  id: Scalars['ID'];
  requiredOption?: Maybe<ProductOption>;
  size: DisplaySize;
  supportingAspectRatioId: Scalars['ID'];
};

export type CreativeFormatAttribute = {
  aspectRatio?: Maybe<CreativeFormatAspectRatio>;
  fastStart?: Maybe<CreativeFormatFastStart>;
  playbackTime?: Maybe<CreativeFormatPlaybackTime>;
};

export type CreativeFormatCreativeType = {
  id: Scalars['ID'];
  key: CreativeFormatCreativeTypeKey;
  name: Scalars['String'];
  requiredPoints: Array<ProductPricing>;
};

export enum CreativeFormatCreativeTypeKey {
  StaticImage = 'static_image',
  Video = 'video'
}

export type CreativeFormatFastStart = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type CreativeFormatNetwork = {
  id: Scalars['ID'];
  key: CreativeFormatNetworkKey;
  name: Scalars['String'];
  placements: Array<SupportingCreativeFormatPlacement>;
};

export enum CreativeFormatNetworkKey {
  Amazon = 'amazon',
  AnyNetwork = 'any_network',
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google',
  Instagram = 'instagram',
  Line = 'line',
  Other = 'other',
  OwnedMedia = 'owned_media',
  Snapchat = 'snapchat',
  Twitter = 'twitter',
  Yahoo = 'yahoo',
  Youtube = 'youtube'
}

export type CreativeFormatPlacement = {
  basicMerchandises: Array<Basic>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type CreativeFormatPlaybackTime = {
  id: Scalars['ID'];
  requiredOption?: Maybe<ProductOption>;
  seconds: Scalars['Int'];
  supportingPlaybackTimeId: Scalars['ID'];
};

export enum Currency {
  Jpy = 'JPY',
  Usd = 'USD'
}

export type Deliverable = {
  attachedThumbnail?: Maybe<Creative>;
  createdAt: Scalars['ISO8601String'];
  creationId: Scalars['ID'];
  creative: Creative;
  id: Scalars['ID'];
  intent: Scalars['String'];
  state: DeliverableState;
  stateUpdatedAt: Scalars['ISO8601String'];
  uploadedAdPlatformKeys: Array<Scalars['String']>;
};

export enum DeliverableState {
  InspectionModificationRequested = 'inspection_modification_requested',
  ModificationRequested = 'modification_requested',
  Submitted = 'submitted'
}

export type DesignInspirationCase = {
  description: Scalars['String'];
  designInspirationCategory: DesignInspirationCategory;
  id: Scalars['ID'];
  name: Scalars['String'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type DesignInspirationCategory = {
  designInspirationCases: Array<DesignInspirationCase>;
  iconUrl: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DisplaySize = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type DynamicSchemaDefinition = {
  id: Scalars['ID'];
  sections: Array<DynamicSchemaDefinitionSection>;
};

export type DynamicSchemaDefinitionChoice = {
  key: Scalars['String'];
  label: Scalars['String'];
};

export type DynamicSchemaDefinitionField = DynamicSchemaDefinitionFileIds | DynamicSchemaDefinitionFiles | DynamicSchemaDefinitionFixed | DynamicSchemaDefinitionMultiLineText | DynamicSchemaDefinitionPositiveInteger | DynamicSchemaDefinitionSelectMultiple | DynamicSchemaDefinitionSelectOne | DynamicSchemaDefinitionSingleLineText | DynamicSchemaDefinitionToggle;

export type DynamicSchemaDefinitionFieldInterface = {
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export enum DynamicSchemaDefinitionFieldType {
  FileIds = 'FILE_IDS',
  Files = 'FILES',
  Fixed = 'FIXED',
  MultiLineText = 'MULTI_LINE_TEXT',
  PositiveInteger = 'POSITIVE_INTEGER',
  SelectMultiple = 'SELECT_MULTIPLE',
  SelectOne = 'SELECT_ONE',
  SingleLineText = 'SINGLE_LINE_TEXT',
  Toggle = 'TOGGLE'
}

export type DynamicSchemaDefinitionFileIds = DynamicSchemaDefinitionFieldInterface & {
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionFiles = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionFixed = DynamicSchemaDefinitionFieldInterface & {
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
  value: Scalars['String'];
};

export type DynamicSchemaDefinitionMultiLineText = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  placeholder: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionPositiveInteger = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionSection = {
  description: Scalars['String'];
  fields: Array<DynamicSchemaDefinitionField>;
  id: Scalars['ID'];
  label: Scalars['String'];
  meta?: Maybe<Scalars['KeyValueObject']>;
};

export type DynamicSchemaDefinitionSelectMultiple = DynamicSchemaDefinitionFieldInterface & {
  choices: Array<DynamicSchemaDefinitionChoice>;
  helperText: Scalars['String'];
  isRequiredToSelectAnything: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionSelectOne = DynamicSchemaDefinitionFieldInterface & {
  choices: Array<DynamicSchemaDefinitionChoice>;
  helperText: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionSingleLineText = DynamicSchemaDefinitionFieldInterface & {
  helperText: Scalars['String'];
  isRequired: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  placeholder: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
};

export type DynamicSchemaDefinitionToggle = DynamicSchemaDefinitionFieldInterface & {
  checkedControlLabel: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: DynamicSchemaDefinitionFieldType;
  uncheckedControlLabel: Scalars['String'];
};

export type Feedback = {
  body: Scalars['String'];
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
};

export type File = {
  attribute: FileAttributeType;
  fastStart?: Maybe<FileFastStart>;
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  originalFileName: Scalars['String'];
  size: Scalars['Int'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FileAspectRatioType = {
  size: FileDisplaySizeItemType;
};

export type FileAttributeType = {
  aspectRatio?: Maybe<FileAspectRatioType>;
  playbackTime?: Maybe<FilePlaybackTimeType>;
  volume?: Maybe<FileVolumeType>;
};

export type FileDisplaySizeItemType = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type FileFastStart = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type FilePlaybackTimeType = {
  seconds: Scalars['Float'];
};

export type FileVolumeType = {
  maxVolume?: Maybe<Scalars['Float']>;
};

export type Index = {
  keyFrames: Array<Keyframe>;
  keywords: Array<Keyword>;
  watchingRatings: Array<WatchingRating>;
};

export type InspectionRequest = {
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  items: Array<InspectionRequestItem>;
  targetDeliverableId: Scalars['ID'];
};

export type InspectionRequestItem = {
  body: Scalars['String'];
  type: InspectionRequestItemType;
};

export type InspectionRequestItemType = {
  id: Scalars['ID'];
  label: Scalars['String'];
};


export type Issue = {
  comments: Array<IssueComment>;
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  resolved: Scalars['Boolean'];
};

export type IssueComment = {
  assetIds: Array<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601String'];
  user: User;
};

export type Keyframe = {
  end: Scalars['TimeObject'];
  start: Scalars['TimeObject'];
  thumbnailImageUrl: Scalars['String'];
};


export type Keyword = {
  sections?: Maybe<Array<KeywordSection>>;
  text: Scalars['String'];
};

export type KeywordSection = {
  end: Scalars['TimeObject'];
  start: Scalars['TimeObject'];
};

export enum MatchingFormat {
  Auto = 'auto',
  Competition = 'competition'
}

export type MatchingFormatGroup = {
  adminAvailableFormats?: Maybe<Array<MatchingFormat>>;
  availableFormats: Array<MatchingFormat>;
  name?: Maybe<Scalars['String']>;
};

export type ModificationRequestDeliverable = {
  attachedThumbnail?: Maybe<Creative>;
  createdAt: Scalars['ISO8601String'];
  creative: Creative;
  id: Scalars['ID'];
  intent: Scalars['String'];
};

export enum ModificationRequestFeeType {
  Fee = 'fee',
  NoFee = 'no_fee'
}

export type OfferPricingDetail = {
  basicPricings: Array<OfferPricingDetailItem>;
  optionPricings: Array<OfferPricingDetailItem>;
};

export type OfferPricingDetailItem = {
  actionType: Scalars['String'];
  amount: Scalars['Int'];
  itemGroupKey?: Maybe<Scalars['String']>;
  itemGroupName?: Maybe<Scalars['String']>;
  itemType: Scalars['String'];
  point: Scalars['Int'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Scalars['String'];
};

export type OptimizerMutation = {
  createDeliverable?: Maybe<Deliverable>;
  createModificationRequestDeliverable?: Maybe<ModificationRequestDeliverable>;
  createModificationRequestItemIssue?: Maybe<Issue>;
  createModificationRequestItemIssueComment?: Maybe<IssueComment>;
  createProjectIssue?: Maybe<Issue>;
  createProjectIssueComment?: Maybe<IssueComment>;
  deleteProjectIssueComment?: Maybe<Issue>;
  reopenModificationRequestIssue?: Maybe<Issue>;
  resolveModificationRequestIssue?: Maybe<Scalars['Void']>;
  touchToTheModificationRequest?: Maybe<Request>;
  updateProjectIssueComment?: Maybe<IssueComment>;
};


export type OptimizerMutationCreateDeliverableArgs = {
  assignmentId: Scalars['ID'];
  attachedThumbnailId?: Maybe<Scalars['ID']>;
  creativeFormatId: Scalars['ID'];
  fileId: Scalars['ID'];
  intent: Scalars['String'];
};


export type OptimizerMutationCreateModificationRequestDeliverableArgs = {
  attachedThumbnailId?: Maybe<Scalars['ID']>;
  fileId: Scalars['ID'];
  intent: Scalars['String'];
  targetModificationRequestId: Scalars['ID'];
};


export type OptimizerMutationCreateModificationRequestItemIssueArgs = {
  assetIds?: Maybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  bucketId?: Maybe<Scalars['String']>;
  modificationRequestItemId: Scalars['ID'];
  name: Scalars['String'];
};


export type OptimizerMutationCreateModificationRequestItemIssueCommentArgs = {
  assetIds: Array<Scalars['String']>;
  body: Scalars['String'];
  bucketId?: Maybe<Scalars['String']>;
  issueId: Scalars['ID'];
};


export type OptimizerMutationCreateProjectIssueArgs = {
  body: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['ID'];
};


export type OptimizerMutationCreateProjectIssueCommentArgs = {
  body: Scalars['String'];
  issueId: Scalars['ID'];
};


export type OptimizerMutationDeleteProjectIssueCommentArgs = {
  commentId: Scalars['ID'];
};


export type OptimizerMutationReopenModificationRequestIssueArgs = {
  issueId: Scalars['ID'];
};


export type OptimizerMutationResolveModificationRequestIssueArgs = {
  issueId: Scalars['ID'];
};


export type OptimizerMutationTouchToTheModificationRequestArgs = {
  id: Scalars['ID'];
};


export type OptimizerMutationUpdateProjectIssueCommentArgs = {
  body: Scalars['String'];
  commentId: Scalars['ID'];
};

export type OptimizerQuery = {
  creation?: Maybe<Creation>;
  creationSet: CreationSet;
  me?: Maybe<User>;
  project?: Maybe<Project>;
  projectChange?: Maybe<ProjectChange>;
};


export type OptimizerQueryCreationArgs = {
  id: Scalars['ID'];
};


export type OptimizerQueryCreationSetArgs = {
  assignmentId?: Maybe<Scalars['ID']>;
  creationSetId?: Maybe<Scalars['ID']>;
  offerId?: Maybe<Scalars['ID']>;
};


export type OptimizerQueryProjectArgs = {
  creationSetId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['ID']>;
};


export type OptimizerQueryProjectChangeArgs = {
  projectId: Scalars['ID'];
};

export type Option = {
  displayToOptimizer: Scalars['Boolean'];
  helpUrlForDirector?: Maybe<Scalars['String']>;
  helpUrlForOptimizer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pricingTables: Array<PricingTable>;
};

export type Organization = {
  businessRegion: BusinessRegion;
  features: OrganizationFeatures;
  id: Scalars['ID'];
  name: Scalars['String'];
  pointBalance?: Maybe<Scalars['Int']>;
};

export type OrganizationFeatures = {
  canOpenOfferWhenDisagreed: Scalars['Boolean'];
};

export type PerformanceReport = {
  adAccount: PerformanceReportAdAccount;
  campaigns: Array<PerformanceReportCampaign>;
  comparisonTargets: Array<PerformanceReportComparisonTarget>;
  dimensions: Array<PerformanceReportDimension>;
  id: Scalars['ID'];
  lastUpdatedAt: Scalars['ISO8601String'];
  metrics: Array<PerformanceReportMetric>;
  periodPatterns: Array<PerformanceReportPeriodPattern>;
};

export type PerformanceReportAdAccount = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  network: PerformanceReportNetwork;
};

export type PerformanceReportCampaign = {
  id: Scalars['ID'];
  /** キャンペーンの名前 */
  name: Scalars['String'];
};

export enum PerformanceReportComparisonTarget {
  All = 'all',
  StaticImage = 'static_image',
  Video = 'video'
}

export enum PerformanceReportDimension {
  Ad = 'ad',
  Age = 'age',
  Gender = 'gender',
  Placement = 'placement'
}

export enum PerformanceReportMetric {
  ClickThroughRate = 'click_through_rate',
  Clicks = 'clicks',
  Conversions = 'conversions',
  CostPerAction = 'cost_per_action',
  CostPerClick = 'cost_per_click',
  CostPerMille = 'cost_per_mille',
  Impressions = 'impressions',
  ReturnOnAdvertisingSpend = 'return_on_advertising_spend',
  Sales = 'sales',
  Spend = 'spend',
  VideoViewRateP100 = 'video_view_rate_p100',
  VideoViewRateP25 = 'video_view_rate_p25',
  VideoViewRateP50 = 'video_view_rate_p50',
  VideoViewRateP75 = 'video_view_rate_p75',
  VideoViewRateP95 = 'video_view_rate_p95',
  ViewThroughConversions = 'view_through_conversions',
  ViewThroughCostPerAction = 'view_through_cost_per_action'
}

export enum PerformanceReportNetwork {
  Amazon = 'amazon',
  Facebook = 'facebook',
  Google = 'google',
  Yahoo = 'yahoo'
}

export enum PerformanceReportPeriodPattern {
  Last_30Days = 'last_30_days',
  Last_7Days = 'last_7_days',
  LastMonth = 'last_month',
  LastWeek = 'last_week',
  Lifetime = 'lifetime'
}

export enum PersonalInformationStatus {
  Active = 'ACTIVE',
  Blank = 'BLANK',
  Blocked = 'BLOCKED'
}

export type PricingTable = {
  cells: Array<PricingTableCell>;
  creativeTypeId: Scalars['ID'];
};

export type PricingTableCell = {
  prices: Array<ProductPricing>;
  supportingAspectRatioKey: Scalars['String'];
  supportingPlaybackTimeLength?: Maybe<Scalars['String']>;
};

export type ProductOption = {
  amount: Scalars['Int'];
  name: Scalars['String'];
  points: Array<ProductOptionPoint>;
};

export type ProductOptionPoint = {
  key: Scalars['String'];
  point: Scalars['Int'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Scalars['String'];
};

export type ProductPricing = {
  key: Scalars['String'];
  point: Scalars['Int'];
  rewardAmount: Scalars['Int'];
  rewardCurrency: Scalars['String'];
};

export type Project = {
  adVideos: Array<Video>;
  assetCategoryDefinition?: Maybe<DynamicSchemaDefinition>;
  assetCategoryUpdatedAt?: Maybe<Scalars['ISO8601String']>;
  assetCategoryValues?: Maybe<Scalars['KeyValueObject']>;
  bucketId?: Maybe<Scalars['ID']>;
  canCreativeVisibilityOnProfile: Scalars['Boolean'];
  canIssueComment: Scalars['Boolean'];
  createdAt: Scalars['ISO8601String'];
  createdBy: UserDirector;
  creationSet?: Maybe<CreationSet>;
  creativeBriefDefinition: DynamicSchemaDefinition;
  creativeBriefUpdatedAt?: Maybe<Scalars['ISO8601String']>;
  creativeBriefValues: Scalars['KeyValueObject'];
  deliveryDueDate?: Maybe<Scalars['ISO8601String']>;
  demo: Scalars['Boolean'];
  designInspirationCase?: Maybe<DesignInspirationCase>;
  finalized: Scalars['Boolean'];
  hasChanges: Scalars['Boolean'];
  id: Scalars['ID'];
  issue?: Maybe<Issue>;
  matchingFormat: MatchingFormat;
  organization: Organization;
  originId: Scalars['ID'];
  parentId?: Maybe<Scalars['ID']>;
  performanceReports: Array<PerformanceReport>;
  progressSummary: ProjectProgressSummary;
  projectType: ProjectType;
  state: ProjectState;
  submittedAt?: Maybe<Scalars['ISO8601String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601String'];
  versionId?: Maybe<Scalars['ID']>;
};

export type ProjectChange = {
  beforeVersion: ProjectDiff;
  latestVersion: ProjectDiff;
  updatedAt: Scalars['ISO8601String'];
};

export type ProjectDiff = {
  assetCategory?: Maybe<Scalars['KeyValueObject']>;
  creativeBrief: Scalars['KeyValueObject'];
};

export type ProjectProgressSummary = {
  approvedCount: Scalars['Int'];
  modificationRequestCount: Scalars['Int'];
  modificationRequestFeedbackCount: Scalars['Int'];
  orderCount: Scalars['Int'];
};

export enum ProjectState {
  Assigned = 'assigned',
  Canceled = 'canceled',
  Draft = 'draft',
  Submitted = 'submitted'
}

export type ProjectType = {
  assetCategoryDefinition?: Maybe<DynamicSchemaDefinition>;
  createdAt: Scalars['ISO8601String'];
  creativeBriefDefinition: DynamicSchemaDefinition;
  description: Scalars['String'];
  designInspirationCategories: Array<DesignInspirationCategory>;
  displayPriority: Scalars['Int'];
  expectedDeliveryPeriod: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  matchingFormatGroup: MatchingFormatGroup;
  maxConceptCount: Scalars['Int'];
  minConceptCount: Scalars['Int'];
  minimumPoint: Scalars['Int'];
  outputSpecification: Scalars['String'];
  popularity: Scalars['Float'];
  pricingMerchandiseOptions: Array<Option>;
  published: Scalars['Boolean'];
  regulation: Scalars['String'];
  sampleVideoUrl?: Maybe<Scalars['String']>;
  supportingCreativeFormatNetworks: Array<SupportingCreativeFormatNetwork>;
  thumbnailImageUrl: Scalars['String'];
  title: Scalars['String'];
  version: Scalars['Int'];
};

export type Request = {
  approvedAt?: Maybe<Scalars['ISO8601String']>;
  bucketId?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601String'];
  creation: Creation;
  deliverables: Array<ModificationRequestDeliverable>;
  deliveryDue?: Maybe<Scalars['ISO8601String']>;
  feedback?: Maybe<Feedback>;
  feeType: ModificationRequestFeeType;
  id: Scalars['ID'];
  items: Array<RequestItem>;
  offerPricingDetail?: Maybe<OfferPricingDetail>;
  sender: UserDirector;
  state: RequestState;
  submittedAt?: Maybe<Scalars['ISO8601String']>;
  targetDeliverableId: Scalars['ID'];
  touchedAt?: Maybe<Scalars['ISO8601String']>;
};

export type RequestItem = {
  assetIds: Array<Scalars['String']>;
  body: Scalars['String'];
  bucketId?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601String'];
  id: Scalars['ID'];
  issue?: Maybe<Issue>;
  metadata: Scalars['KeyValueObject'];
  sender: UserDirector;
  type?: Maybe<Scalars['Int']>;
  typeName?: Maybe<Scalars['String']>;
};

export enum RequestState {
  Approved = 'approved',
  Draft = 'draft',
  GivenFeedback = 'given_feedback',
  Responded = 'responded',
  Submitted = 'submitted'
}

export type Reward = {
  amount: Scalars['Int'];
  currency: Currency;
  quota: Scalars['Int'];
};

export type SupportingCreativeFormatAspectRatio = {
  availables: Array<SupportingCreativeFormatAspectRatioItem>;
  id: Scalars['ID'];
};

export type SupportingCreativeFormatAspectRatioItem = {
  aspectRatio: AspectRatio;
  presetSize: DisplaySize;
  requiredOption?: Maybe<ProductOption>;
};

export type SupportingCreativeFormatAttribute = {
  aspectRatio?: Maybe<SupportingCreativeFormatAspectRatio>;
  fastStart?: Maybe<SupportingCreativeFormatFastStart>;
  playbackTime?: Maybe<SupportingCreativeFormatPlaybackTime>;
};

export type SupportingCreativeFormatCreativeType = {
  attribute: SupportingCreativeFormatAttribute;
  id: Scalars['ID'];
  key: CreativeFormatCreativeTypeKey;
  name: Scalars['String'];
  requiredPoints: Array<ProductPricing>;
};

export type SupportingCreativeFormatFastStart = {
  availables?: Maybe<Array<SupportingCreativeFormatFastStartItem>>;
  id: Scalars['ID'];
};

export type SupportingCreativeFormatFastStartItem = {
  enabled: Scalars['Boolean'];
};

export type SupportingCreativeFormatNetwork = {
  id: Scalars['ID'];
  key: CreativeFormatNetworkKey;
  name: Scalars['String'];
  placements: Array<SupportingCreativeFormatPlacement>;
};

export type SupportingCreativeFormatPlacement = {
  basicMerchandises: Array<Basic>;
  creativeTypes: Array<SupportingCreativeFormatCreativeType>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  pricingTables: Array<PricingTable>;
};

export type SupportingCreativeFormatPlaybackTime = {
  availables: Array<SupportingCreativeFormatPlaybackTimeItem>;
  id: Scalars['ID'];
};

export type SupportingCreativeFormatPlaybackTimeItem = {
  requiredOption?: Maybe<ProductOption>;
  seconds: Scalars['Int'];
};

export type SupportingCreativeType = {
  id: Scalars['ID'];
  key: CreativeFormatCreativeTypeKey;
  name: Scalars['String'];
};


export type User = UserDirector | UserOptimizer;

export type UserDirector = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  profileImageUrl: Scalars['String'];
};

export type UserOptimizer = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  personalInformationStatus?: Maybe<PersonalInformationStatus>;
  profileImageUrl: Scalars['String'];
};

export type Video = {
  adAnalyticsVideoIndex?: Maybe<Index>;
  adVideoId: Scalars['ID'];
  analyzingState: VideoAnalyzingState;
  clicks: Scalars['Float'];
  conversions: Scalars['Float'];
  conversionsKey?: Maybe<Scalars['String']>;
  cpa?: Maybe<Scalars['Float']>;
  cpaWithViewThroughConversions?: Maybe<Scalars['Float']>;
  cpc?: Maybe<Scalars['Float']>;
  cpm?: Maybe<Scalars['Float']>;
  ctr?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  cvr: Scalars['Float'];
  duration: Scalars['Float'];
  impressions: Scalars['Float'];
  medias: Array<AdAnalyticsNetwork>;
  mobileAppInstalls?: Maybe<Scalars['Float']>;
  placements: Array<AdAnalyticsPlacement>;
  platforms: Array<AdAnalyticsPlatform>;
  project?: Maybe<Project>;
  spend: Scalars['Float'];
  thumbnailImageUrl: Scalars['String'];
  title: Scalars['String'];
  videoUrl: Scalars['String'];
  viewThroughConversions: Scalars['Float'];
};

export enum VideoAnalyzingState {
  NotAnalyze = 'not_analyze',
  Processed = 'processed',
  Processing = 'processing'
}


export type WatchingRating = {
  rate: Scalars['Float'];
  until: Scalars['Int'];
};

export type SingleCreationForDetailFragment = (
  Pick<Creation, 'id' | 'assignmentId' | 'state' | 'proposed' | 'createdAt' | 'stateUpdatedAt'>
  & { assignee?: Maybe<Pick<UserOptimizer, 'id' | 'name' | 'profileImageUrl'>>, deliverables: Array<(
    Pick<Deliverable, 'id' | 'state' | 'createdAt' | 'stateUpdatedAt' | 'intent'>
    & { creative: (
      Pick<Creative, 'id'>
      & { file: (
        Pick<File, 'id' | 'originalFileName' | 'url' | 'size' | 'mimeType'>
        & { fastStart?: Maybe<Pick<FileFastStart, 'enabled'>>, attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
      ) }
    ), attachedThumbnail?: Maybe<(
      Pick<Creative, 'id'>
      & { file: (
        Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'>
        & { fastStart?: Maybe<Pick<FileFastStart, 'enabled'>>, attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
      ) }
    )> }
  )>, modificationRequests: Array<(
    Pick<Request, 'id' | 'bucketId' | 'state' | 'targetDeliverableId' | 'feeType' | 'createdAt' | 'deliveryDue'>
    & { feedback?: Maybe<Pick<Feedback, 'id' | 'body' | 'createdAt'>>, sender: Pick<UserDirector, 'id' | 'name' | 'profileImageUrl'>, items: Array<(
      Pick<RequestItem, 'id' | 'type' | 'typeName' | 'assetIds' | 'body' | 'metadata'>
      & { sender: Pick<UserDirector, 'id' | 'name' | 'profileImageUrl'>, issue?: Maybe<(
        Pick<Issue, 'id' | 'name' | 'resolved'>
        & { comments: Array<(
          Pick<IssueComment, 'id' | 'body' | 'assetIds' | 'createdAt'>
          & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
        )> }
      )> }
    )>, deliverables: Array<(
      Pick<ModificationRequestDeliverable, 'id' | 'createdAt' | 'intent'>
      & { creative: (
        Pick<Creative, 'id'>
        & { file: Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'> }
      ), attachedThumbnail?: Maybe<(
        Pick<Creative, 'id'>
        & { file: Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'> }
      )> }
    )>, offerPricingDetail?: Maybe<{ basicPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>>, optionPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }> }
  )>, creativeFormat: (
    Pick<CreativeFormat, 'id' | 'resizeBaseId'>
    & { network: Pick<CreativeFormatNetwork, 'id' | 'key' | 'name'>, placement: Pick<CreativeFormatPlacement, 'id' | 'key' | 'name'>, creativeType: Pick<CreativeFormatCreativeType, 'id' | 'key' | 'name'>, attribute: { aspectRatio?: Maybe<(
        Pick<CreativeFormatAspectRatio, 'supportingAspectRatioId'>
        & { requiredOption?: Maybe<(
          Pick<ProductOption, 'name' | 'amount'>
          & { points: Array<Pick<ProductOptionPoint, 'key' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }
        )>, aspectRatio: Pick<AspectRatio, 'width' | 'height'>, size: Pick<DisplaySize, 'width' | 'height'> }
      )>, playbackTime?: Maybe<(
        Pick<CreativeFormatPlaybackTime, 'supportingPlaybackTimeId' | 'seconds'>
        & { requiredOption?: Maybe<(
          Pick<ProductOption, 'name' | 'amount'>
          & { points: Array<Pick<ProductOptionPoint, 'key' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }
        )> }
      )>, fastStart?: Maybe<Pick<CreativeFormatFastStart, 'enabled'>> }, offerPricingDetails?: Maybe<{ basicPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>>, optionPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }> }
  ) }
);

export type ProjectForCreationSetDetailFragment = (
  Pick<Project, 'id' | 'bucketId' | 'creativeBriefValues' | 'assetCategoryValues' | 'title' | 'matchingFormat' | 'hasChanges' | 'canIssueComment'>
  & { projectType: (
    Pick<ProjectType, 'key' | 'id' | 'version' | 'title' | 'description' | 'thumbnailImageUrl' | 'sampleVideoUrl' | 'expectedDeliveryPeriod' | 'outputSpecification' | 'regulation'>
    & { creativeBriefDefinition: (
      Pick<DynamicSchemaDefinition, 'id'>
      & { sections: Array<(
        Pick<DynamicSchemaDefinitionSection, 'id' | 'label' | 'description' | 'meta'>
        & { fields: Array<Pick<DynamicSchemaDefinitionFiles, 'key' | 'type' | 'label' | 'helperText'> | Pick<DynamicSchemaDefinitionFixed, 'key' | 'type' | 'label' | 'value'> | Pick<DynamicSchemaDefinitionMultiLineText, 'key' | 'type' | 'label' | 'placeholder' | 'helperText' | 'isRequired'> | Pick<DynamicSchemaDefinitionPositiveInteger, 'key' | 'type' | 'label' | 'helperText' | 'isRequired'> | (
          Pick<DynamicSchemaDefinitionSelectMultiple, 'key' | 'type' | 'label' | 'helperText' | 'isRequiredToSelectAnything'>
          & { choices: Array<Pick<DynamicSchemaDefinitionChoice, 'key' | 'label'>> }
        ) | (
          Pick<DynamicSchemaDefinitionSelectOne, 'key' | 'type' | 'label' | 'helperText'>
          & { choices: Array<Pick<DynamicSchemaDefinitionChoice, 'key' | 'label'>> }
        ) | Pick<DynamicSchemaDefinitionSingleLineText, 'key' | 'type' | 'label' | 'placeholder' | 'helperText' | 'isRequired'> | Pick<DynamicSchemaDefinitionToggle, 'key' | 'type' | 'label' | 'checkedControlLabel' | 'uncheckedControlLabel'>> }
      )> }
    ), supportingCreativeFormatNetworks: Array<(
      Pick<SupportingCreativeFormatNetwork, 'id' | 'key' | 'name'>
      & { placements: Array<(
        Pick<SupportingCreativeFormatPlacement, 'id' | 'key' | 'name'>
        & { creativeTypes: Array<(
          Pick<SupportingCreativeFormatCreativeType, 'id' | 'key' | 'name'>
          & { attribute: { aspectRatio?: Maybe<(
              Pick<SupportingCreativeFormatAspectRatio, 'id'>
              & { availables: Array<{ aspectRatio: Pick<AspectRatio, 'width' | 'height'>, presetSize: Pick<DisplaySize, 'width' | 'height'> }> }
            )>, playbackTime?: Maybe<(
              Pick<SupportingCreativeFormatPlaybackTime, 'id'>
              & { availables: Array<Pick<SupportingCreativeFormatPlaybackTimeItem, 'seconds'>> }
            )> } }
        )> }
      )> }
    )> }
  ), designInspirationCase?: Maybe<Pick<DesignInspirationCase, 'id' | 'name' | 'description' | 'url' | 'thumbnailUrl'>>, creativeBriefDefinition: (
    Pick<DynamicSchemaDefinition, 'id'>
    & { sections: Array<(
      Pick<DynamicSchemaDefinitionSection, 'id' | 'label' | 'description' | 'meta'>
      & { fields: Array<Pick<DynamicSchemaDefinitionFiles, 'key' | 'type' | 'label' | 'helperText'> | Pick<DynamicSchemaDefinitionFixed, 'key' | 'type' | 'label' | 'value'> | Pick<DynamicSchemaDefinitionMultiLineText, 'key' | 'type' | 'label' | 'placeholder' | 'helperText' | 'isRequired'> | Pick<DynamicSchemaDefinitionPositiveInteger, 'key' | 'type' | 'label' | 'helperText' | 'isRequired'> | (
        Pick<DynamicSchemaDefinitionSelectMultiple, 'key' | 'type' | 'label' | 'helperText' | 'isRequiredToSelectAnything'>
        & { choices: Array<Pick<DynamicSchemaDefinitionChoice, 'key' | 'label'>> }
      ) | (
        Pick<DynamicSchemaDefinitionSelectOne, 'key' | 'type' | 'label' | 'helperText'>
        & { choices: Array<Pick<DynamicSchemaDefinitionChoice, 'key' | 'label'>> }
      ) | Pick<DynamicSchemaDefinitionSingleLineText, 'key' | 'type' | 'label' | 'placeholder' | 'helperText' | 'isRequired'> | Pick<DynamicSchemaDefinitionToggle, 'key' | 'type' | 'label' | 'checkedControlLabel' | 'uncheckedControlLabel'>> }
    )> }
  ), assetCategoryDefinition?: Maybe<(
    Pick<DynamicSchemaDefinition, 'id'>
    & { sections: Array<(
      Pick<DynamicSchemaDefinitionSection, 'id' | 'meta' | 'label' | 'description'>
      & { fields: Array<Pick<DynamicSchemaDefinitionFileIds, 'key' | 'type' | 'label'> | Pick<DynamicSchemaDefinitionMultiLineText, 'key' | 'type' | 'label' | 'placeholder' | 'helperText' | 'isRequired'> | (
        Pick<DynamicSchemaDefinitionSelectOne, 'key' | 'type' | 'label' | 'helperText'>
        & { choices: Array<Pick<DynamicSchemaDefinitionChoice, 'key' | 'label'>> }
      ) | Pick<DynamicSchemaDefinitionSingleLineText, 'key' | 'type' | 'label' | 'placeholder' | 'helperText' | 'isRequired'>> }
    )> }
  )>, organization: (
    Pick<Organization, 'id' | 'name'>
    & { businessRegion: Pick<BusinessRegion, 'key'> }
  ), issue?: Maybe<(
    Pick<Issue, 'id' | 'name'>
    & { comments: Array<(
      Pick<IssueComment, 'id' | 'body' | 'updatedAt' | 'createdAt'>
      & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
    )> }
  )> }
);

export type CreationSetForCreationSetDetailFragment = (
  Pick<CreationSet, 'id' | 'amount' | 'expressDueDays' | 'currentAssignmentId'>
  & { project: ProjectForCreationSetDetailFragment, creationsByAssignmentId: Array<SingleCreationForDetailFragment>, creationsByOtherAssignedOptimizers: Array<SingleCreationForDetailFragment>, creativeFormats: Array<(
    Pick<CreativeFormat, 'id' | 'resizeBaseId'>
    & { selectedPricingMerchandiseOptions: Array<Pick<Option, 'id' | 'name' | 'displayToOptimizer' | 'helpUrlForOptimizer'>>, network: Pick<CreativeFormatNetwork, 'id' | 'key' | 'name'>, placement: Pick<CreativeFormatPlacement, 'id' | 'key' | 'name'>, creativeType: Pick<CreativeFormatCreativeType, 'id' | 'key' | 'name'>, attribute: { aspectRatio?: Maybe<(
        Pick<CreativeFormatAspectRatio, 'supportingAspectRatioId'>
        & { requiredOption?: Maybe<(
          Pick<ProductOption, 'name' | 'amount'>
          & { points: Array<Pick<ProductOptionPoint, 'key' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }
        )>, aspectRatio: Pick<AspectRatio, 'width' | 'height'>, size: Pick<DisplaySize, 'width' | 'height'> }
      )>, playbackTime?: Maybe<(
        Pick<CreativeFormatPlaybackTime, 'supportingPlaybackTimeId' | 'seconds'>
        & { requiredOption?: Maybe<(
          Pick<ProductOption, 'name' | 'amount'>
          & { points: Array<Pick<ProductOptionPoint, 'key' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }
        )> }
      )>, fastStart?: Maybe<Pick<CreativeFormatFastStart, 'enabled'>> }, offerPricingDetails?: Maybe<{ basicPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>>, optionPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }> }
  )> }
);

export type CreationSetQueryVariables = Exact<{
  offerId?: Maybe<Scalars['ID']>;
  creationSetId?: Maybe<Scalars['ID']>;
  assignmentId?: Maybe<Scalars['ID']>;
}>;


export type CreationSetQuery = { creationSet: CreationSetForCreationSetDetailFragment };

export type GetCreationByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCreationByIdQuery = { creation?: Maybe<(
    Pick<Creation, 'id' | 'assignmentId' | 'state' | 'proposed' | 'projectId' | 'createdAt' | 'stateUpdatedAt' | 'achievementId' | 'creationSetId'>
    & { assignee?: Maybe<Pick<UserOptimizer, 'id' | 'name' | 'profileImageUrl'>>, deliverables: Array<(
      Pick<Deliverable, 'id' | 'state' | 'createdAt' | 'stateUpdatedAt' | 'intent'>
      & { creative: (
        Pick<Creative, 'id'>
        & { file: (
          Pick<File, 'id' | 'originalFileName' | 'url' | 'size' | 'mimeType'>
          & { fastStart?: Maybe<Pick<FileFastStart, 'enabled'>>, attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>>, volume?: Maybe<Pick<FileVolumeType, 'maxVolume'>> } }
        ) }
      ), attachedThumbnail?: Maybe<(
        Pick<Creative, 'id'>
        & { file: (
          Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'>
          & { attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
        ) }
      )> }
    )>, inspectionModificationRequests: Array<(
      Pick<InspectionRequest, 'id' | 'targetDeliverableId' | 'createdAt'>
      & { items: Array<(
        Pick<InspectionRequestItem, 'body'>
        & { type: Pick<InspectionRequestItemType, 'id' | 'label'> }
      )> }
    )>, modificationRequests: Array<(
      Pick<Request, 'id' | 'bucketId' | 'state' | 'targetDeliverableId' | 'feeType' | 'createdAt' | 'submittedAt' | 'deliveryDue' | 'touchedAt'>
      & { feedback?: Maybe<Pick<Feedback, 'id' | 'body' | 'createdAt'>>, sender: Pick<UserDirector, 'id' | 'name' | 'profileImageUrl'>, items: Array<(
        Pick<RequestItem, 'id' | 'type' | 'typeName' | 'assetIds' | 'body' | 'metadata'>
        & { sender: Pick<UserDirector, 'id' | 'name' | 'profileImageUrl'>, issue?: Maybe<(
          Pick<Issue, 'id' | 'name' | 'resolved'>
          & { comments: Array<(
            Pick<IssueComment, 'id' | 'body' | 'assetIds' | 'createdAt'>
            & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
          )> }
        )> }
      )>, deliverables: Array<(
        Pick<ModificationRequestDeliverable, 'id' | 'createdAt' | 'intent'>
        & { creative: (
          Pick<Creative, 'id'>
          & { file: (
            Pick<File, 'id' | 'originalFileName' | 'url' | 'size' | 'mimeType'>
            & { fastStart?: Maybe<Pick<FileFastStart, 'enabled'>>, attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>>, volume?: Maybe<Pick<FileVolumeType, 'maxVolume'>> } }
          ) }
        ), attachedThumbnail?: Maybe<(
          Pick<Creative, 'id'>
          & { file: (
            Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'>
            & { attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
          ) }
        )> }
      )>, offerPricingDetail?: Maybe<{ basicPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>>, optionPricings: Array<Pick<OfferPricingDetailItem, 'itemType' | 'actionType' | 'itemGroupName' | 'itemGroupKey' | 'amount' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }> }
    )>, creativeFormat: (
      Pick<CreativeFormat, 'id' | 'resizeBaseId'>
      & { network: Pick<CreativeFormatNetwork, 'id' | 'key' | 'name'>, placement: Pick<CreativeFormatPlacement, 'id' | 'key' | 'name'>, creativeType: Pick<CreativeFormatCreativeType, 'id' | 'key' | 'name'>, attribute: { aspectRatio?: Maybe<(
          Pick<CreativeFormatAspectRatio, 'supportingAspectRatioId'>
          & { requiredOption?: Maybe<(
            Pick<ProductOption, 'name' | 'amount'>
            & { points: Array<Pick<ProductOptionPoint, 'key' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }
          )>, aspectRatio: Pick<AspectRatio, 'width' | 'height'>, size: Pick<DisplaySize, 'width' | 'height'> }
        )>, playbackTime?: Maybe<(
          Pick<CreativeFormatPlaybackTime, 'supportingPlaybackTimeId' | 'seconds'>
          & { requiredOption?: Maybe<(
            Pick<ProductOption, 'name' | 'amount'>
            & { points: Array<Pick<ProductOptionPoint, 'key' | 'point' | 'rewardAmount' | 'rewardCurrency'>> }
          )> }
        )>, fastStart?: Maybe<Pick<CreativeFormatFastStart, 'enabled'>> }, selectedPricingMerchandiseOptions: Array<Pick<Option, 'name' | 'displayToOptimizer' | 'helpUrlForOptimizer'>> }
    ) }
  )> };

export type CreateDeliverableMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
  creativeFormatId: Scalars['ID'];
  fileId: Scalars['ID'];
  attachedThumbnailId?: Maybe<Scalars['ID']>;
  intent: Scalars['String'];
}>;


export type CreateDeliverableMutation = { createDeliverable?: Maybe<(
    Pick<Deliverable, 'id' | 'creationId' | 'intent' | 'state' | 'createdAt' | 'stateUpdatedAt'>
    & { creative: (
      Pick<Creative, 'id'>
      & { file: (
        Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'>
        & { attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
      ) }
    ), attachedThumbnail?: Maybe<(
      Pick<Creative, 'id'>
      & { file: (
        Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'>
        & { attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
      ) }
    )> }
  )> };

export type TouchToTheModificationRequestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TouchToTheModificationRequestMutation = { touchToTheModificationRequest?: Maybe<(
    Pick<Request, 'id' | 'bucketId' | 'state' | 'targetDeliverableId' | 'feeType' | 'createdAt' | 'submittedAt' | 'deliveryDue'>
    & { feedback?: Maybe<Pick<Feedback, 'id' | 'body' | 'createdAt'>>, sender: Pick<UserDirector, 'id' | 'name' | 'profileImageUrl'>, items: Array<(
      Pick<RequestItem, 'id' | 'bucketId' | 'type' | 'typeName' | 'assetIds' | 'body' | 'metadata'>
      & { sender: Pick<UserDirector, 'id' | 'name' | 'profileImageUrl'>, issue?: Maybe<(
        Pick<Issue, 'id' | 'name' | 'resolved'>
        & { comments: Array<(
          Pick<IssueComment, 'id' | 'body' | 'assetIds' | 'createdAt'>
          & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
        )> }
      )> }
    )>, deliverables: Array<(
      Pick<ModificationRequestDeliverable, 'id' | 'createdAt' | 'intent'>
      & { creative: (
        Pick<Creative, 'id'>
        & { file: (
          Pick<File, 'originalFileName' | 'url' | 'mimeType'>
          & { attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'height' | 'width'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>>, volume?: Maybe<Pick<FileVolumeType, 'maxVolume'>> }, fastStart?: Maybe<Pick<FileFastStart, 'enabled'>> }
        ) }
      ), attachedThumbnail?: Maybe<(
        Pick<Creative, 'id'>
        & { file: (
          Pick<File, 'originalFileName' | 'url' | 'mimeType' | 'size'>
          & { attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'height' | 'width'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>>, volume?: Maybe<Pick<FileVolumeType, 'maxVolume'>> }, fastStart?: Maybe<Pick<FileFastStart, 'enabled'>> }
        ) }
      )> }
    )> }
  )> };

export type CreateModificationRequestItemIssueMutationVariables = Exact<{
  modificationRequestItemId: Scalars['ID'];
  name: Scalars['String'];
  body: Scalars['String'];
}>;


export type CreateModificationRequestItemIssueMutation = { createModificationRequestItemIssue?: Maybe<(
    Pick<Issue, 'id' | 'name' | 'resolved'>
    & { comments: Array<(
      Pick<IssueComment, 'id' | 'body' | 'assetIds' | 'createdAt'>
      & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
    )> }
  )> };

export type CreateModificationRequestItemIssueCommentMutationVariables = Exact<{
  issueId: Scalars['ID'];
  body: Scalars['String'];
  bucketId?: Maybe<Scalars['String']>;
  assetIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateModificationRequestItemIssueCommentMutation = { createModificationRequestItemIssueComment?: Maybe<(
    Pick<IssueComment, 'id' | 'body' | 'assetIds' | 'createdAt'>
    & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
  )> };

export type ResolveModificationRequestIssueMutationVariables = Exact<{
  issueId: Scalars['ID'];
}>;


export type ResolveModificationRequestIssueMutation = Pick<OptimizerMutation, 'resolveModificationRequestIssue'>;

export type ReopenModificationRequestIssueMutationVariables = Exact<{
  issueId: Scalars['ID'];
}>;


export type ReopenModificationRequestIssueMutation = { reopenModificationRequestIssue?: Maybe<(
    Pick<Issue, 'id' | 'name' | 'resolved'>
    & { comments: Array<(
      Pick<IssueComment, 'id' | 'body' | 'assetIds' | 'createdAt'>
      & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
    )> }
  )> };

export type CreateModificationRequestDeliverableMutationVariables = Exact<{
  targetModificationRequestId: Scalars['ID'];
  fileId: Scalars['ID'];
  attachedThumbnailId?: Maybe<Scalars['ID']>;
  intent: Scalars['String'];
}>;


export type CreateModificationRequestDeliverableMutation = { createModificationRequestDeliverable?: Maybe<(
    Pick<ModificationRequestDeliverable, 'id' | 'intent' | 'createdAt'>
    & { creative: (
      Pick<Creative, 'id'>
      & { file: (
        Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'>
        & { fastStart?: Maybe<Pick<FileFastStart, 'enabled'>>, attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>>, volume?: Maybe<Pick<FileVolumeType, 'maxVolume'>> } }
      ) }
    ), attachedThumbnail?: Maybe<(
      Pick<Creative, 'id'>
      & { file: (
        Pick<File, 'id' | 'originalFileName' | 'url' | 'mimeType' | 'size'>
        & { attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
      ) }
    )> }
  )> };

export type GetProjectChangeQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type GetProjectChangeQuery = { projectChange?: Maybe<(
    Pick<ProjectChange, 'updatedAt'>
    & { latestVersion: Pick<ProjectDiff, 'creativeBrief' | 'assetCategory'>, beforeVersion: Pick<ProjectDiff, 'creativeBrief' | 'assetCategory'> }
  )> };

export type CreationSetForProjectFragment = (
  Pick<CreationSet, 'id' | 'offerId' | 'amount' | 'expressDueDays'>
  & { creativeFormats: Array<(
    Pick<CreativeFormat, 'id' | 'resizeBaseId'>
    & { network: Pick<CreativeFormatNetwork, 'id' | 'key' | 'name'>, placement: Pick<CreativeFormatPlacement, 'id' | 'key' | 'name'>, creativeType: Pick<CreativeFormatCreativeType, 'id' | 'key' | 'name'>, attribute: { aspectRatio?: Maybe<(
        Pick<CreativeFormatAspectRatio, 'supportingAspectRatioId'>
        & { aspectRatio: Pick<AspectRatio, 'width' | 'height'>, size: Pick<DisplaySize, 'width' | 'height'> }
      )>, playbackTime?: Maybe<Pick<CreativeFormatPlaybackTime, 'supportingPlaybackTimeId' | 'seconds'>> }, selectedPricingMerchandiseOptions: Array<Pick<Option, 'id' | 'name' | 'displayToOptimizer' | 'helpUrlForOptimizer'>> }
  )>, inspectionPassedCreations?: Maybe<Array<(
    Pick<Creation, 'id' | 'state' | 'proposed' | 'createdAt'>
    & { assignee?: Maybe<Pick<UserOptimizer, 'id' | 'name' | 'profileImageUrl'>>, latestProposedDeliverable?: Maybe<(
      Pick<Deliverable, 'id' | 'state' | 'createdAt' | 'stateUpdatedAt' | 'intent'>
      & { creative: (
        Pick<Creative, 'id'>
        & { file: (
          Pick<File, 'id' | 'originalFileName' | 'url' | 'size' | 'mimeType'>
          & { fastStart?: Maybe<Pick<FileFastStart, 'enabled'>>, attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
        ) }
      ), attachedThumbnail?: Maybe<(
        Pick<Creative, 'id'>
        & { file: (
          Pick<File, 'id' | 'url' | 'originalFileName' | 'mimeType' | 'size'>
          & { fastStart?: Maybe<Pick<FileFastStart, 'enabled'>>, attribute: { aspectRatio?: Maybe<{ size: Pick<FileDisplaySizeItemType, 'width' | 'height'> }>, playbackTime?: Maybe<Pick<FilePlaybackTimeType, 'seconds'>> } }
        ) }
      )> }
    )> }
  )>> }
);

export type GetProjectByIdQueryVariables = Exact<{
  projectId?: Maybe<Scalars['ID']>;
  creationSetId?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['ID']>;
}>;


export type GetProjectByIdQuery = { project?: Maybe<(
    Pick<Project, 'originId' | 'parentId' | 'state' | 'createdAt' | 'submittedAt'>
    & { createdBy: Pick<UserDirector, 'id' | 'name' | 'profileImageUrl'>, creationSet?: Maybe<CreationSetForProjectFragment> }
    & ProjectForCreationSetDetailFragment
  )> };

export type CreateProjectIssueMutationVariables = Exact<{
  projectId: Scalars['ID'];
  name: Scalars['String'];
  body: Scalars['String'];
}>;


export type CreateProjectIssueMutation = { createProjectIssue?: Maybe<(
    Pick<Issue, 'id' | 'name'>
    & { comments: Array<(
      Pick<IssueComment, 'id' | 'body' | 'createdAt' | 'updatedAt'>
      & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
    )> }
  )> };

export type CreateProjectIssueCommentMutationVariables = Exact<{
  issueId: Scalars['ID'];
  body: Scalars['String'];
}>;


export type CreateProjectIssueCommentMutation = { createProjectIssueComment?: Maybe<(
    Pick<IssueComment, 'id' | 'body' | 'createdAt' | 'updatedAt'>
    & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
  )> };

export type UpdateProjectIssueCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
  body: Scalars['String'];
}>;


export type UpdateProjectIssueCommentMutation = { updateProjectIssueComment?: Maybe<(
    Pick<IssueComment, 'id' | 'body' | 'createdAt' | 'updatedAt'>
    & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
  )> };

export type DeleteProjectIssueCommentMutationVariables = Exact<{
  commentId: Scalars['ID'];
}>;


export type DeleteProjectIssueCommentMutation = { deleteProjectIssueComment?: Maybe<(
    Pick<Issue, 'id' | 'name'>
    & { comments: Array<(
      Pick<IssueComment, 'id' | 'body' | 'createdAt' | 'updatedAt'>
      & { user: Pick<UserDirector, 'id' | 'name' | 'email' | 'profileImageUrl'> | Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl'> }
    )> }
  )> };

export type OptimizerUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OptimizerUserQuery = { me?: Maybe<Pick<UserOptimizer, 'id' | 'name' | 'email' | 'profileImageUrl' | 'personalInformationStatus'>> };
